import React from 'react';
import List from '../../models/validation/List';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ListValidation(props) {

    const { t } = useTranslation();
    const { params } = props.match;

    return (
        <div>
            <br />
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                    <li className="breadcrumb-item"><Link to={'/Validations/'}>{t("Validation_Breadcrumb_Title")}</Link></li>
                </ol>
            </nav>
            <br />
            <List />
            <br />
            <br />
        </div >
    );

}
